import {
  SizeLargeIcon,
  SizeMediumIcon,
  SizeSmallIcon
} from "./../../../plugin-commons/index.js";
import {
  AlignCenterIcon,
  AlignLeftIcon,
  AlignRightIcon
} from "./../../../toolbars-ui/index.js";
import {
  SIZE_DROPDDOWN_OPTION_LARGE,
  SIZE_DROPDDOWN_OPTION_MEDIUM,
  SIZE_DROPDDOWN_OPTION_SMALL,
  STYLE_DROPDOWN_OPTION_DASHED,
  STYLE_DROPDOWN_OPTION_DOTTED,
  STYLE_DROPDOWN_OPTION_DOUBLE,
  STYLE_DROPDOWN_OPTION_SINGLE
} from "../../data-hooks.js";
import {
  DashedLineStyle,
  DottedLineStyle,
  DoubleLineStyle,
  SingleLineStyle
} from "../../icons/index.js";
const dividerSizeData = [
  {
    text: "SizeSmallButton_Tooltip",
    tooltip: "SizeSmallButton_Tooltip",
    commandKey: "SMALL",
    icon: SizeSmallIcon,
    dataHook: SIZE_DROPDDOWN_OPTION_SMALL
  },
  {
    text: "SizeContentButton_Tooltip",
    tooltip: "SizeContentButton_Tooltip",
    commandKey: "MEDIUM",
    icon: SizeMediumIcon,
    dataHook: SIZE_DROPDDOWN_OPTION_MEDIUM
  },
  {
    text: "SizeFullWidthButton_Tooltip",
    tooltip: "SizeFullWidthButton_Tooltip",
    commandKey: "LARGE",
    icon: SizeLargeIcon,
    dataHook: SIZE_DROPDDOWN_OPTION_LARGE
  }
];
const dividerStyleData = [
  {
    commandKey: "SINGLE",
    icon: SingleLineStyle,
    dataHook: STYLE_DROPDOWN_OPTION_SINGLE
  },
  {
    commandKey: "DOUBLE",
    icon: DoubleLineStyle,
    dataHook: STYLE_DROPDOWN_OPTION_DOUBLE
  },
  {
    commandKey: "DASHED",
    icon: DashedLineStyle,
    dataHook: STYLE_DROPDOWN_OPTION_DASHED
  },
  {
    commandKey: "DOTTED",
    icon: DottedLineStyle,
    dataHook: STYLE_DROPDOWN_OPTION_DOTTED
  }
];
const alignmentMap = {
  LEFT: AlignLeftIcon,
  CENTER: AlignCenterIcon,
  RIGHT: AlignRightIcon
};
export {
  alignmentMap,
  dividerSizeData,
  dividerStyleData
};
//# sourceMappingURL=dividerButtonsData.js.map
